var style={
	list:[
		// {
		// 	pid:1,
		// 	list:[
		// 		{
		// 			pid:1,
		// 			id:1,
		// 			name:'短期个人款',	
		// 		},
		// 		{
		// 			pid:1,
		// 			id:2,
		// 			name:'年度个人至尊款',	
		// 		},
		// 		{},{}
		// 	]
		// },
		{
			pid:1
		},
		{
			pid:2,
			list:[
				{
					pid:3,
					id:1,
					name:'经典家庭款',	
				},
				{
					pid:3,
					id:2,
					name:'精英个人款 ',	
				},
				// {
				// 	pid:3,
				// 	id:3,
				// 	name:'经典个人款',
				// },
				{
					pid:3,
					id:3,
					name:'尊享家庭款',
				},
				{}
			]
		},
		{
			pid:3
		},
		{
      pid:5
    },
    {
      pid:6
		},
    {
      pid:7
		}
	],
	worry:[{
		pid:1,
		list:[{
			id:1,
			date:'01 / 04',
			tit:'境外丢失证件',
			text: '我语言不通谁来陪我在当地完成补办？'
		},
		{
			id:2,
			date:'02 / 04',
			tit:'旅游期间受伤生病',
			text: '谁陪我去就医、住院后谁来照顾我？ '
		},
		{
			id:3,
			date:'03 / 04',
			tit:'当地医疗水平太差',
			text: '谁能帮我尽快转到其他城市的大医院？ '
		},
		{
			id:4,
			date:'04 / 04',
			tit:'手术后想尽快回国',
			text: '行动不便、只能平躺怎么上飞机？'
		}]
	},{
		pid:2,
		list:[{
			id:1,
			date:'01 / 04',
			tit:'首次出国留学',
			text: '受伤生病谁陪我去就医？住院后谁来照顾我？'
		},
		{
			id:2,
			date:'02 / 04',
			tit:'国外遇到安全事故',
			text: '事故发生后我如何求救？谁来帮我？'
		},
		{
			id:3,
			date:'03 / 04',
			tit:'环境陌生适应障碍',
			text: '心理、法律问题我该咨询谁？该找谁帮我缓解？ '
		},
		{
			id:4,
			date:'04 / 04',
			tit:'个人财务、证件丢失',
			text: '流程不懂，谁陪我在当地完成补办？'
		}]
	},{
		pid:3,
		list:[{
			id:1,
			date:'01 / 04',
			tit:'境外丢失证件',
			text: '我语言不通谁来陪我在当地完成补办？'
		},
		{
			id:2,
			date:'02 / 04',
			tit:'旅游期间受伤生病',
			text: '谁陪我去就医、住院后谁来照顾我？ '
		},
		{
			id:3,
			date:'03 / 04',
			tit:'当地医疗水平太差',
			text: '谁能帮我尽快转到其他城市的大医院？ '
		},
		{
			id:4,
			date:'04 / 04',
			tit:'手术后想尽快回国',
			text: '行动不便、只能平躺怎么上飞机？'
		}]
	},{
		pid:4,
		list:[{
			id:1,
			date:'01 / 04',
			tit:'突发死亡事件',
			text: '海外遗体处理或转运手续繁琐，甚至被搁置。'
		},
		{
			id:2,
			date:'02 / 04',
			tit:'长期住院治疗',
			text: '异国他乡生病住院，希望获得亲友前来探望。 '
		},
		{
			id:3,
			date:'03 / 04',
			tit:'当地医疗水平太差',
			text: '谁能帮我尽快转到其他城市的大医院？ '
		},
		{
			id:4,
			date:'04 / 04',
			tit:'手术后想尽快回国',
			text: '行动不便、只能平躺怎么上飞机？'
		}]
  },
  {
		pid:5,
		list:[{
			id:1,
			date:'01 / 04',
			tit:'中转期间被检测出新冠',
			text: '人在境外环境陌生、语言不通，谁能给我一些就医帮助？'
		},
		{
			id:2,
			date:'02 / 04',
			tit:'境外确诊后被隔离',
			text: '心理压力大、身体不适，隔离期间我如何获得医生指导？ '
		},
		{
			id:3,
			date:'03 / 04',
			tit:'因新冠导致原行程作废',
			text: '在中转国被确诊，原行程机票无法退票改签，谁能帮我安排下一行程？ '
		},
		{
			id:4,
			date:'04 / 04',
			tit:'境外医疗费支付难',
			text: '境外支付医疗费用不方便，谁能帮我担保或垫付？'
		}]
  },
  {
		pid:6,
		list:[{
			id:1,
			date:'01 / 04',
			tit:'旅游期间受伤生病',
			text: '谁能给我一些就医指导？'
		},
		{
			id:2,
			date:'02 / 04',
			tit:'伤势较重行动困难',
			text: '谁能帮我通知亲人朋友？'
		},
		{
			id:3,
			date:'03 / 04',
			tit:'当地医疗水平不足',
			text: '谁能帮我尽快转到其他城市的大医院？ '
		},
		{
			id:4,
			date:'04 / 04',
			tit:'医疗费用支付困难',
			text: '谁能帮我减少经济损失？'
		}]
  },
  {
		pid:7,
		list:[{
			id:1,
			date:'01 / 04',
			tit:'境外疑似或确诊新冠',
			text: '谁能帮我提供检测/就医指导？'
		},
		{
			id:2,
			date:'02 / 04',
			tit:'确诊后被安排独自隔离',
			text: '谁能给我一些心理辅导或医疗建议？'
		},
		{
			id:3,
			date:'03 / 04',
			tit:'当地医疗水平不足',
			text: '谁能帮我尽快转到其他城市的大医院？ '
		},
		{
			id:4,
			date:'04 / 04',
			tit:'病情严重需要照料',
			text: '谁能替我安排亲属探访？'
		}]
  }
],
	bright:[
		{
			id:1,
			list:[{
				tit:'一键救援',
				text:'实时定位便捷呼救'
			},
			{
				tit:'双语星使',
				text:'海外华人协助服务'
			},
			{
				tit:'风险预警',
				text:'全球实时风险信息'
			}],
		},{
			id:2,
			list:[{
				tit:'无年龄限制'
			},
			{
				tit:'无既往病史限制'
			},
			{
				tit:'无危险运动限制'
			}]
		},{
			id:3,
			list:[{
				tit:'无救援次数限制'
			},
			{
				tit:'无救援费用限制'
			},
			{
				tit:'24小时救援服务'
			}]
		}
	]
}
export default style;


// WEBPACK FOOTER //
// ./src/views/rescuelist/js/style.js